import { render } from "./AgreementTemplates.vue?vue&type=template&id=47d832e5"
import script from "./AgreementTemplates.vue?vue&type=script&lang=js"
export * from "./AgreementTemplates.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__